const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const initSlider = (root) => {
  if (root.dataset.drvSliderReady) return;
  const track = root.querySelector('[data-drv-slider-track]');
  const slider = root.querySelector('[data-drv-slider-controls]');
  const bars = root.querySelector('[data-drv-slider-bars]');
  const prev = root.querySelector('[data-drv-slider-prev]');
  const next = root.querySelector('[data-drv-slider-next]');
  if (!track || !slider || !bars || !track.firstElementChild) return;
  root.dataset.drvSliderReady = '1';

  const step = () => {
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return track.firstElementChild.getBoundingClientRect().width + gap;
  };
  const overflow = () => track.scrollWidth - track.clientWidth;
  const positions = () => (overflow() < 2 ? 1 : Math.round(overflow() / step()) + 1);
  const index = () => {
    if (overflow() - track.scrollLeft < 2) return positions() - 1;
    return Math.min(positions() - 1, Math.max(0, Math.round(track.scrollLeft / step())));
  };

  const render = () => {
    const count = positions();
    slider.classList.toggle('is-idle', count < 2);
    if (bars.children.length !== count) {
      bars.replaceChildren(
        ...Array.from({ length: count }, () => {
          const bar = document.createElement('span');
          bar.className = 'drv-slider__bar';
          return bar;
        })
      );
    }
    const current = index();
    [...bars.children].forEach((bar, n) => bar.classList.toggle('is-active', n === current));
    if (prev) prev.disabled = current === 0;
    if (next) next.disabled = current === count - 1;
  };

  const move = (direction) => {
    track.scrollBy({ left: direction * step(), behavior: reducedMotion() ? 'auto' : 'smooth' });
  };
  prev?.addEventListener('click', () => move(-1));
  next?.addEventListener('click', () => move(1));
  track.addEventListener('scroll', render, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(render).observe(track);
  if (window.DrvDrag) window.DrvDrag.scroll(track);
  render();
};

const init = () => document.querySelectorAll('[data-drv-slider]').forEach(initSlider);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
document.addEventListener('shopify:section:load', init);
